// jQuery(document.body).on('added_to_cart', function() {
//   jQuery('.cart-count').addClass('updated');
//   console.log('added_to_cart');
//   setTimeout(function() {
//     jQuery('.cart-count').removeClass('updated');

//   }, 400);
// });
document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.mm_icon').addEventListener('click', function () {
    const headerNav = document.querySelector('.header_nav');
    const body = document.body;
    headerNav.classList.toggle('mm_active');
    if (headerNav.classList.contains('mm_active')) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  });

  const productDropdown = document.querySelectorAll('.accordion-toggle');

  productDropdown.forEach(toggle => {
    toggle.addEventListener('click', function () {
      this.classList.toggle('active');
      const content = this.nextElementSibling;

      if (content.style.display === "none" || content.style.display === "") {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    });
  });

  const faq = document.querySelector('.bby_faq');
  if (!faq) return;
  const detailsList = faq.querySelectorAll('details');
  detailsList.forEach((detail) => {
    const summary = detail.querySelector('summary');
    const content = detail.querySelector('p');
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      detailsList.forEach((el) => {
        if (el !== detail) {
          el.removeAttribute('open');
          el.querySelector('p').style.maxHeight = null;
        }
      });
      const isOpen = detail.hasAttribute('open');
      if (isOpen) {
        detail.removeAttribute('open');
        content.style.maxHeight = null;
      } else {
        detail.setAttribute('open', '');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
  
});
jQuery(document).ready(function ($) {
  jQuery('.bb_slider_wrapper').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 1,
    fade: true,
    adaptiveHeight: true,
  });

  function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("reveal_active");
      } else {
        reveals[i].classList.remove("reveal_active");
      }
    }
  }
  window.addEventListener("scroll", reveal);
  reveal();
});




// Woocomerce variant picker
document.addEventListener("DOMContentLoaded", function () {
  const variationsTable = document.querySelector(".variations");
  if (variationsTable && variationsTable.offsetParent !== null) {
    const labels = variationsTable.querySelectorAll("label");
    labels.forEach(label => {
      label.addEventListener("click", function () {
        const tr = label.closest("tr");
        if (tr) {
          tr.classList.add("active");
        }
      });
    });
  }
});
